import { configureStore } from '@reduxjs/toolkit'
import walletReducer from "./slice/walletSlice"; 
import currencyReducer from "./slice/currencySlice"; 
import todoSlice from './slice/todoSlice';
import toastSlice from './slice/toastsSlice';
import txnSlice from './slice/txnSlice';

export const store = configureStore({
  reducer: {
    wallet: walletReducer,
    currency :currencyReducer, 
    toast: toastSlice,
    statements: txnSlice,
    todo: todoSlice,   
  },
});

export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch